(function () {
  if (window.innerWidth >= 750) return;

  var selector = '.player-addplaylist, .player-playtrack-button, .product-details__player-addplaylist';

  function markPlayerTap(event) {
    var trigger = event.target.closest && event.target.closest(selector);
    if (!trigger) return;

    trigger.classList.add('cchw-player-triggered');
    trigger.classList.add('is-loading-track');

    window.clearTimeout(trigger.cchwPlayerLoadingTimer);
    trigger.cchwPlayerLoadingTimer = window.setTimeout(function () {
      trigger.classList.remove('cchw-player-triggered');
      trigger.classList.remove('is-loading-track');
    }, 700);
  }

  document.addEventListener('touchstart', markPlayerTap, { passive: true });
  document.addEventListener('click', markPlayerTap, { passive: true });
})();
